import { Component, Input, OnDestroy, OnInit } from "@angular/core";
import {
  Aangifte,
  BokkzAlgDataService,
  IncomeTaxEntity,
  JaarrekeningBalans
} from "@snelstart-ventures/fiscaal/domain-logic";
import { BehaviorSubject, filter, Subscription, take } from "rxjs";
import { FormBuilder, FormGroup, ReactiveFormsModule } from '@angular/forms';
import {BokkzIbDataService} from "@snelstart-ventures/fiscaal/domain-logic";
import { Event, NavigationEnd, Router } from "@angular/router";
import { SharedUiDialogModule } from '@snelstart/ui-dialog';
import { SharedUiDetailsModule } from '@snelstart/ui-details';
import { SharedUiFormControlsModule } from '@snelstart/ui-form-controls';
import { SharedUiButtonModule } from '@snelstart/ui-button';
import { CommonModule } from '@angular/common';
import { SharedUiAlertModule } from '@snelstart/ui-alert';

@Component({
  selector: 'snelstart-venture-fiscaal-feature-spec-gebouwen-eigen',
  templateUrl: './spec-gebouwen-eigen.component.html',
  styleUrls: ['./spec-gebouwen-eigen.component.scss'],
    imports: [
        SharedUiDialogModule,
        ReactiveFormsModule,
        SharedUiDetailsModule,
        SharedUiFormControlsModule,
        SharedUiButtonModule,
        CommonModule,
        SharedUiAlertModule
    ]
})
export class SpecGebouwenEigenComponent implements OnInit,OnDestroy {
    private routerSubscription: Subscription | undefined;
    private incomeTaxEntitySubscription: Subscription | undefined;
    private clientEntitySubscription: Subscription | undefined;
    private isSaving = false;
    @Input() public id!: string;
    public clientId!: string;
    public incomeTaxEntity = {} as IncomeTaxEntity;
    public partnerBoolean = {} as boolean;
    @Input() partner = new BehaviorSubject<boolean>(false);

    public showSpinner = true;

    public gebouwenEigenFg = {} as FormGroup;
    public dialogVisible = false;

    showDialog() {
        this.dialogVisible = true;
    }

    constructor(
        public dataService: BokkzIbDataService, public dataAlgService: BokkzAlgDataService,
        private router: Router,
        private fb: FormBuilder) {
        this.gebouwenEigenFg = this.fb.group<JaarrekeningBalans>({
            waardeOpening: null as unknown as number,
            waardeSlot: null as unknown as number,
            aanschafWaarde: null as unknown as number,
            restWaarde: null as unknown as number,
            bodemwaarde: null as unknown as number,
            gebruikBinnenEigenOnderneming: true,
            omschrijving: 'bedrijfsGebouwen'
        })
    }

    private resetFormGroup() {
        this.gebouwenEigenFg.setValue({
            waardeOpening: null as unknown as number,
            waardeSlot: null as unknown as number,
            aanschafWaarde: null as unknown as number,
            restWaarde: null as unknown as number,
            bodemwaarde: null as unknown as number,
            gebruikBinnenEigenOnderneming: true,
            omschrijving: 'bedrijfsGebouwen'
        }, {emitEvent: false})
    }


    ngOnInit(): void {
      this.incomeTaxEntitySubscription =this.dataService.incomeTaxEntity.subscribe((incomeTaxEntity) => {
            this.incomeTaxEntity = incomeTaxEntity;
            if (incomeTaxEntity.aangifte) {
                this.partner.subscribe((partner) => {
                    this.partnerBoolean = partner;
                    this.resetFormGroup();
                    const onderneming = !partner ? this.incomeTaxEntity.aangifte?.box1?.winstUitOnderneming?.ondernemingen[0] : this.incomeTaxEntity.aangifte?.partnerAangifte?.box1?.winstUitOnderneming?.ondernemingen[0];
                    const gebouwen = onderneming?.materieleVasteActiva?.find(item => item.omschrijving === 'bedrijfsGebouwen') as JaarrekeningBalans;
                    this.gebouwenEigenFg.patchValue(gebouwen);
                })
            }
        })
      this.clientEntitySubscription = this.dataAlgService.client.subscribe((client) =>{
        if (client.sstRelationId) {
          this.clientId=client.sstRelationId;
        }
      })
      this.routerSubscription = this.router.events.pipe(filter((event: Event): event is NavigationEnd => event instanceof NavigationEnd,),)
        .subscribe((event: NavigationEnd) => {
          this.handleUrlChange(event.urlAfterRedirects);
        });
    }

  ngOnDestroy(): void {
    if (this.routerSubscription) {
      this.routerSubscription.unsubscribe(); // Unsubscribe to avoid memory leaks
    }
    if (this.incomeTaxEntitySubscription) {
      this.incomeTaxEntitySubscription.unsubscribe();
    }
    if (this.clientEntitySubscription) {
      this.clientEntitySubscription.unsubscribe();
    }
  }

  handleUrlChange(newUrl: string) {
    if (!this.isSaving && this.hasUnsavedChanges()) {
      this.isSaving = true;
      this.dataService.postIncomeTaxEntity(this.clientId,false, this.incomeTaxEntity);
      this.isSaving = false;
    }
  }

  private hasUnsavedChanges(): boolean {
    return this.gebouwenEigenFg.dirty
  }

    saveForm(): void {
      this.partner.pipe(take(1)).subscribe((partner) => {
        const ondernemingen = !partner
          ? this.incomeTaxEntity.aangifte?.box1?.winstUitOnderneming?.ondernemingen
          : this.incomeTaxEntity.aangifte?.partnerAangifte?.box1?.winstUitOnderneming?.ondernemingen;
        if (ondernemingen) {
          const gebouw = ondernemingen[0]?.materieleVasteActiva?.find(item => item.omschrijving === 'bedrijfsGebouwen');
          if (gebouw) {
            Object.assign(gebouw, this.gebouwenEigenFg.getRawValue());
          }

          this.incomeTaxEntity.aangifte = {
            ...this.incomeTaxEntity.aangifte,
            ...(partner &&
              { partnerAangifte:
                  { ...this.incomeTaxEntity.aangifte?.partnerAangifte } }),
          } as Aangifte;

          this.dataService.updateIncomeTaxEntity(this.incomeTaxEntity);
        }
      });
    }

    public heeftOndernemingen(): boolean {
        if (this.partnerBoolean) {
            return !!(this.incomeTaxEntity &&
                this.incomeTaxEntity.aangifte?.partnerAangifte &&
                this.incomeTaxEntity.aangifte?.partnerAangifte.box1 &&
                this.incomeTaxEntity.aangifte?.partnerAangifte.box1.winstUitOnderneming &&
                this.incomeTaxEntity.aangifte?.partnerAangifte.box1.winstUitOnderneming.ondernemingen &&
                this.incomeTaxEntity.aangifte?.partnerAangifte.box1.winstUitOnderneming.ondernemingen.length > 0);
        } else {
            return !!(this.incomeTaxEntity.aangifte &&
                this.incomeTaxEntity.aangifte?.box1 &&
                this.incomeTaxEntity.aangifte?.box1.winstUitOnderneming &&
                this.incomeTaxEntity.aangifte?.box1.winstUitOnderneming.ondernemingen &&
                this.incomeTaxEntity.aangifte?.box1.winstUitOnderneming.ondernemingen.length > 0);
        }
    }
}
